@if (relations.length === 0) {
<span class="text-gray-300 text-sm">—</span>
} @else {
<div class="relative inline-block">
    <div class="flex gap-1 items-center flex-wrap">
        @for (rel of relations; track rel.type + '-' + rel.id) {
        <button type="button" (click)="toggle($event)"
            class="border-none rounded-md px-2 py-0.5 text-[11px] font-extrabold cursor-pointer"
            [style.background]="meta(rel.type).bg" [style.color]="meta(rel.type).color">
            {{ meta(rel.type).short }}·{{ rel.id_by_company }}
        </button>
        }
    </div>

    @if (isOpen) {
    <div class="absolute top-7.5 left-0 z-50 bg-white border border-gray-200 rounded-lg shadow-xl w-65 p-2.5">
        <div class="text-[11px] font-bold text-gray-400 uppercase tracking-wide px-1 pb-2">Documentos relacionados</div>
        @for (rel of relations; track rel.type + '-' + rel.id) {
        <div class="flex items-center gap-2.5 py-2 px-1.5 rounded-md mb-1.5 bg-gray-50"
            [style.border-left]="'3px solid ' + meta(rel.type).dot">
            <div class="flex-1">
                <div class="text-[12.5px] font-bold text-gray-800">{{ meta(rel.type).label }} #{{ rel.id_by_company }}</div>
            </div>
            @if (openInNewTab) {
            <a [href]="linkFor(rel)" target="_blank" rel="noopener"
                class="text-[11.5px] font-semibold text-blue-600 no-underline hover:underline">Ver documento</a>
            } @else {
            <a [routerLink]="linkFor(rel)"
                class="text-[11.5px] font-semibold text-blue-600 no-underline hover:underline">Ver documento</a>
            }
        </div>
        }
    </div>
    }
</div>
}
